let counter = 0;

export function generateListenerId(prefix = 'listener') {
    counter++;
    return `${prefix}_${Date.now()}_${counter}_${Math.random().toString(36).substring(2, 9)}`;
}
